export const ItemStatus = {
  1: {
    name: '待处理',
    color: '#1890FF',
  },
  2: {
    name: '处理中',
    color: '#1890FF',
  },
  3: {
    name: '已完成',
    color: '#67C23A',
  },
  4: {
    name: '已逾期',
    color: '#F56C6C',
  },
  5: {
    name: '已废弃',
    color: '#909399',
  },
  6: {
    name: '漏检',
    color: '#F56C6C',
  },
  7: {
    name: '跳检',
    color: '#67C23A',
  },
}

// 分屏模式枚举
export const LAYOUT_MODE = {
  SINGLE: { value: 1, label: '1分屏(1x1)' },
  QUAD: { value: 2, label: '4分屏(2x2)' },
  NINE: { value: 3, label: '9分屏(3x3)' },
  SIXTEEN: { value: 4, label: '16分屏(4x4)' },
}

export const LAYOUT_MODE_OPTIONS = Object.values(LAYOUT_MODE);
export const LAYOUT_MODE_MAP = Object.fromEntries(
  Object.entries(LAYOUT_MODE).map(([key, { value, label }]) => [value, label])
);